(function() {
  'use strict';

  // List of country ISO codes to BLOCK (blacklist). Everything else is allowed.
  // Add codes here, e.g. ['RU', 'IR', 'KP'] to block Russia, Iran, North Korea, etc.
  var BLOCKED_COUNTRIES = ['CN','RU'];   // <-- EDIT THIS LIST (examples: 'RU', 'IR', 'CN', 'KP', 'SY', 'BY')

  // Prevent multiple executions
  if (window.__shopifyCountryBlockerRan) return;
  window.__shopifyCountryBlockerRan = true;

  function getCachedDecision() {
    try {
      return sessionStorage.getItem('__geo_country_block');
    } catch (e) {
      return null;
    }
  }

  function setCachedDecision(value) {
    try {
      sessionStorage.setItem('__geo_country_block', value);
    } catch (e) {}
  }

  function blockVisitor(country) {
    // Option A: Full page replacement (recommended for hard block)
    var html = '<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<title>GameGuard Portal Unavailable</title>' +
      '<style>' +
      'body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;background:#f4f4f4;color:#222;margin:0;padding:40px 20px;display:flex;align-items:center;justify-content:center;min-height:100vh;text-align:center}' +
      '.box{background:#fff;max-width:460px;padding:40px 32px;border-radius:10px;box-shadow:0 2px 12px rgba(0,0,0,.06)}' +
      'h1{font-size:24px;margin:0 0 12px}' +
      'p{color:#555;line-height:1.5;margin:0 0 20px;font-size:15px}' +
      '.note{font-size:12px;color:#888;margin-top:20px}' +
      '</style></head><body><div class="box">' +
      '<h1>GameGuard Portal is not available in your country.</h1>' +
      '<p>Access from your location has been restricted.  If you feel this is incorrect, please contact us at 940-464-4800</p>' +
      '<p class="note">Detected location: ' + (country || 'Unknown') + '<br>If you are using a VPN, try disabling it.</p>' +
      '</div></body></html>';

    // Replace everything immediately
    document.open();
    document.write(html);
    document.close();
    
    // Stop further execution / navigation where possible
    try {
      // Prevent any later scripts from modifying
      Object.defineProperty(document, 'body', { value: document.body, writable: false });
    } catch (e) {}
  }

  function allowVisitor() {
    // Nothing to do – page continues to render normally
    // You could dispatch a custom event here if other code needs to react:
    // document.dispatchEvent(new CustomEvent('shopify:geo-allowed'));
  }

  function checkCountry() {
    var cached = getCachedDecision();
    if (cached === 'blocked') {
      blockVisitor('cached');
      return;
    }
    if (cached === 'allowed') {
      allowVisitor();
      return;
    }

    // Perform country lookup 
    // This provider updates its data regularly.
    fetch('https://api.country.is/', {
      method: 'GET',
      cache: 'no-store',
      // credentials omitted on purpose
    })
    .then(function(response) {
      if (!response.ok) throw new Error('bad response');
      return response.json();
    })
    .then(function(data) {
      var country = (data && data.country ? String(data.country) : '').toUpperCase().trim();
      //alert(data.country);

      if (country && BLOCKED_COUNTRIES.indexOf(country) !== -1) {
        setCachedDecision('blocked');
        blockVisitor(country);
      } else {
        setCachedDecision('allowed');
        allowVisitor();
      }
    })
    .catch(function(err) {
      // On network / API error we currently ALLOW the visitor.
      // Change the line below to blockVisitor('error') if you prefer fail-closed behavior.
      setCachedDecision('allowed');
      allowVisitor();

      console.log('Geo lookup failed, allowing (fail-open):', err);
    });
  }

  // Run as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCountry);
  } else {
    checkCountry();
  }
})();

